<h2>Roles and Permissions</h2>

<div style="overflow-x: auto">
  <table
    class="table table-striped table-condensed"
    style="font-size: 11px; border: 2px solid #bbb"
  >
    <thead>
      <tr>
        <th style="color: cornflowerblue">Permissions</th>
        <th *ngFor="let role of roles" style="text-align: center; border-left: 1px solid #bbb">
          {{ role.Name }}
        </th>
      </tr>
    </thead>
    <tr *ngFor="let permission of permissions">
      <td style="white-space: nowrap">{{ permission.Name }}</td>
      <td
        *ngFor="let role of roles"
        style="font-weight: bold; text-align: center; border-left: 1px solid #bbb"
      >
        {{ isRoleInPermission(role.Name, permission) ? 'x' : '' }}
      </td>
    </tr>
  </table>
</div>
